"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _clientAwsS = require("@devsta/client-aws-s3");

var _BrandError = _interopRequireDefault(require("./BrandError"));

var _Brands = _interopRequireDefault(require("./Brands"));

var _AssetDropdown = _interopRequireDefault(require("./AssetDropdown"));

var _BriefBlock = _interopRequireDefault(require("../../../../BriefBlock"));

require("../styles/_brand-section.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BrandSection = /*#__PURE__*/function (_Component) {
  _inherits(BrandSection, _Component);

  var _super = _createSuper(BrandSection);

  function BrandSection() {
    var _this;

    _classCallCheck(this, BrandSection);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onSelectBrand", function (newBrandId) {
      var _this$props = _this.props,
          onSelectBrand = _this$props.onSelectBrand,
          brandId = _this$props.brandId;
      onSelectBrand(newBrandId);

      if (brandId === newBrandId) {
        return;
      }

      _this.fetchSubBrand(newBrandId);
    });

    _defineProperty(_assertThisInitialized(_this), "fetchSubBrand", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(overrideBrandId) {
        var _this$props2, getSubBrand, fetchAssets, selectedBrandId, brandId, _yield$getSubBrand, data, error, videoTemplates, lowerThird, introAnimation;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props2 = _this.props, getSubBrand = _this$props2.getSubBrand, fetchAssets = _this$props2.fetchAssets, selectedBrandId = _this$props2.brandId;
                brandId = overrideBrandId || selectedBrandId;

                if (brandId) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _context.next = 6;
                return getSubBrand({
                  subBrandId: brandId
                });

              case 6:
                _yield$getSubBrand = _context.sent;
                data = _yield$getSubBrand.data;
                error = _yield$getSubBrand.error;

                if (!(error || !data)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", void _this.setState({
                  subBrandFetchError: true
                }));

              case 11:
                videoTemplates = data.getOrganisationSubBrand.videoTemplates;
                lowerThird = videoTemplates.find(function (template) {
                  return template.name === 'Lower-Third Title';
                });
                introAnimation = videoTemplates.find(function (template) {
                  return template.name === 'Intro Animation';
                });
                fetchAssets(lowerThird);
                fetchAssets(introAnimation);

                _this.setState({
                  lowerThirdAssetIds: lowerThird && lowerThird.assetIds,
                  introAnimationAssetIds: introAnimation && introAnimation.assetIds,
                  subBrandFetchError: false
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "fetchBrands", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props3, getSubBrands, apolloClient, organisationId, _yield$getSubBrands, data, error, brandsWithImages;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props3 = _this.props, getSubBrands = _this$props3.getSubBrands, apolloClient = _this$props3.apolloClient, organisationId = _this$props3.organisationId;
              _context2.next = 3;
              return getSubBrands();

            case 3:
              _yield$getSubBrands = _context2.sent;
              data = _yield$getSubBrands.data;
              error = _yield$getSubBrands.error;

              if (!(error || !data)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                subBrandsFetchError: true
              }));

            case 8:
              _context2.prev = 8;
              _context2.next = 11;
              return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                apiClient: apolloClient,
                dataArray: data.getOrganisationSubBrands,
                substitutedKeys: ['coverImageKey'],
                organisationId: organisationId
              });

            case 11:
              brandsWithImages = _context2.sent;

              _this.setState({
                brands: brandsWithImages,
                subBrandsFetchError: false
              });

              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](8);

              _this.setState({
                subBrandsFetchError: true
              });

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 15]]);
    })));

    _this.state = {
      subBrandsFetchError: false,
      subBrandFetchError: false
    };
    return _this;
  }

  _createClass(BrandSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchBrands();
      this.fetchSubBrand();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          brandId = _this$props4.brandId,
          lowerThirdId = _this$props4.lowerThirdId,
          lowerThirdTitle = _this$props4.lowerThirdTitle,
          lowerThirdDescription = _this$props4.lowerThirdDescription,
          onSelectBrandValue = _this$props4.onSelectBrandValue,
          onChangeField = _this$props4.onChangeField,
          introAnimationId = _this$props4.introAnimationId,
          canUpdateVideo = _this$props4.canUpdateVideo,
          onBlurField = _this$props4.onBlurField;
      var _this$state = this.state,
          brands = _this$state.brands,
          subBrandsFetchError = _this$state.subBrandsFetchError,
          subBrandFetchError = _this$state.subBrandFetchError,
          lowerThirdAssetIds = _this$state.lowerThirdAssetIds,
          introAnimationAssetIds = _this$state.introAnimationAssetIds;
      return /*#__PURE__*/_react.default.createElement(_BriefBlock.default, {
        title: "Which brand guidelines do you want to use for this project?"
      }, subBrandsFetchError ? /*#__PURE__*/_react.default.createElement(_BrandError.default, {
        message: "Something went wrong fetching your Organisation's Brands.",
        onRefetch: this.fetchBrands
      }) : /*#__PURE__*/_react.default.createElement(_Brands.default, {
        brands: brands,
        onSelectBrand: this.onSelectBrand,
        selectedBrandId: brandId,
        canUpdateVideo: canUpdateVideo
      }), brandId && !subBrandFetchError ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", {
        className: "brand-section__divider"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "brand-section__lower-third"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "brand-section__header",
        heading5: true
      }, "Lower Third"), /*#__PURE__*/_react.default.createElement(_AssetDropdown.default, {
        assetIds: lowerThirdAssetIds,
        placeholder: canUpdateVideo ? 'Select lower third' : 'Lower third',
        selectedId: lowerThirdId,
        onSelect: onSelectBrandValue('lowerThirdId'),
        disabled: !canUpdateVideo
      })), lowerThirdId ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "brand-section__lower-third__title"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
        placeholder: canUpdateVideo ? 'Enter title' : 'Title',
        label: "Title",
        onChange: onChangeField('lowerThirdTitle'),
        defaultValue: lowerThirdTitle,
        small: true,
        disabled: !canUpdateVideo,
        onBlur: onBlurField
      })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
        className: "brand-section__lower-third__description",
        placeholder: canUpdateVideo ? 'Enter description' : 'Description',
        label: "Description",
        multiline: true,
        onChange: onChangeField('lowerThirdDescription'),
        small: true,
        defaultValue: lowerThirdDescription,
        disabled: !canUpdateVideo,
        onBlur: onBlurField
      })), /*#__PURE__*/_react.default.createElement("hr", {
        className: "brand-section__divider"
      })) : null, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: "brand-section__header",
        heading5: true
      }, "Intro Animation"), /*#__PURE__*/_react.default.createElement(_AssetDropdown.default, {
        assetIds: introAnimationAssetIds,
        placeholder: canUpdateVideo ? 'Select intro animation' : 'Intro animation',
        selectedId: introAnimationId,
        onSelect: onSelectBrandValue('introAnimationId'),
        disabled: !canUpdateVideo
      })) : subBrandFetchError && /*#__PURE__*/_react.default.createElement(_BrandError.default, {
        message: "Something went wrong fetching your Organisation's Brand.",
        onRefetch: this.fetchSubBrand
      }));
    }
  }]);

  return BrandSection;
}(_react.Component);

exports.default = BrandSection;